module.exports = __webpack_public_path__ + "media/images/flags/64/Sweden-88ffe51505d385e42dbd42584cc0cdd9.png";